/* Charts.ts */

export const STYLE = {
  fontSize: "12px",
  fill: "#aab9ce",
  stroke: "#e8ecf2",
};

export const basicStyles = {
  tooltip: {
    margin: -62,
  },
  font: {
    size: "12px",
    family: "Roboto, sans-serif",
    color: "#587798",
  },
  fontSize: {
    unit: "14px",
  },
  grid: {
    xAxis: {
      color: "#c8d2e0",
      zeroLineColor: "#c8d2e0",
    },
  },
};
